export default {
  militaryStatus: 'military-status',
  releaseDate: 'release-date',
  fileBdd: 'file-bdd',
  unableToFileBdd: 'unable-to-file-bdd',
  claimType: 'claim-type',
  pactEligibility: 'pact-eligibility',
  evidenceNeeded: 'evidence-needed',
};
